import tools from './tools';

// Hugerte component
export default function () {
    let root, textarea, spinner, instance;
    let instantiated = false;

    return {
        get value() {
            return instance ? instance.getContent() : textarea.value;
        },

        set value(value) {
            if (instance) {
                instance.setContent(value);
                instance.save();

                if (root._x_model) {
                    root._x_model.set(instance.getContent());
                }
            } else {
                textarea.value = value;

                if (root._x_model) {
                    root._x_model.set(value);
                }
            }
        },

        instance() {
            return instance;
        },

        init() {
            root = this.$root;
            root.setAttribute('x-ignore', '');

            textarea = this.$refs.textarea;
            spinner = this.$refs.spinner;

            if (this.isInModal) {
                this.instantiate();
            }
        },

        destroy() {
            try {
                instance.destroy(false);
            } catch (error) {}
        },

        instantiate() {
            if (instantiated) return;
            instantiated = true;

            if (root._x_model) {
                const xModelWatcher = (value) => {
                    if (this.value !== value) {
                        this.value = value;
                    }
                };

                this.$watch(tools.getXModelValue(root), xModelWatcher);
                xModelWatcher(root._x_model.get());
            }

            const name = textarea.name;

            if (this.isInModal) {
                spinner.remove();
                spinner = null;
            }

            const placeholderColor = Helper.cssVar('--' + (IS_BOOTSTRAP5 ? 'bs-' : '') + 'secondary');

            hugerte.init({
                target: textarea,
                height: root.style.height,
                placeholder: root.getAttribute('placeholder'),
                skin: false,
                plugins:
                    'accordion advlist anchor autolink charmap code directionality emoticons fullscreen help image insertdatetime link lists media nonbreaking pagebreak preview save searchreplace table visualblocks visualchars wordcount',
                toolbar:
                    'fontfamily fontsize | bold italic underline strikethrough removeformat | forecolor backcolor | align bullist numlist table | link image media hr',
                toolbar_mode: 'floating',
                extended_valid_elements: 'style,script,link',
                custom_elements: 'style,script,link',
                content_style: `body { font-family: arial } body::before { position: absolute; content: attr(data-mce-placeholder); color: ${placeholderColor}; z-index: -1 }`,
                default_font_stack: ['arial'],
                font_family_formats: [
                    'Arial=arial,helvetica,sans-serif',
                    'Comic Sans MS=comic sans ms,sans-serif',
                    'Courier New=courier,monospace',
                    'Georgia=georgia,serif',
                    'Impact=impact,sans-serif',
                    'System Font=system-ui, -apple-system, segoe ui, roboto, arial, sans-serif',
                    'Tahoma=tahoma,sans-serif',
                    'Times New Roman=times-new-roman,serif',
                    'Verdana=verdana,sans-serif',
                ].join(';'),
                font_size_formats: [8, 9, 10, 11, 12, 14, 16, 18, 20, 22, 24, 28, 32, 36, 40, 48, 60].map((size) => `${size}pt`).join(' '),
                setup: (editor) => {
                    instance = editor;

                    let changed = false;

                    editor.on(
                        'input',
                        Alpine.debounce(() => {
                            changed = true;
                            editor.save();

                            if (root._x_model) {
                                root._x_model.set(editor.getContent());
                            }

                            this.$nextTick(() => {
                                root.dispatchEvent(new Event('input'));
                                Helper.dispatchCustomEvent('revalidate', { attribute: name });
                            });
                        }, 200)
                    );

                    editor.on('blur', () => {
                        if (changed) {
                            changed = false;
                            root.dispatchEvent(new Event('change'));
                        }
                    });
                },
                init_instance_callback: (editor) => {
                    root.style.height = '';
                    root.classList.remove('border', 'rounded');

                    if (name) {
                        const container = editor.getContainer();
                        container.setAttribute('error-for', name);
                        container.classList.add('tox-border');

                        document.querySelector(`label[for="${name}"]`)?.addEventListener('click', () => editor.focus());
                    }

                    if (spinner) {
                        spinner.style.opacity = 0;
                        window.setTimeout(() => spinner.remove(), 100);
                    }

                    editor.save();
                },
            });
        },

        focus() {
            if (!instance) return;

            if (instance.initialized) {
                instance.focus();
            } else {
                instance.once('init', () => instance.focus());
            }
        },
    };
}
